import clsx from 'clsx';
import PropTypes from 'prop-types';

export default function Hr({ variant = 'light' }) {
  return (
    <hr
      className={clsx('h-px w-full border-0 bg-gradient-to-r from-transparent to-transparent', {
        'via-event-light/20': variant === 'light',
        'via-corporate-dark/20': variant === 'dark',
      })}
    />
  );
}

Hr.propTypes = {
  variant: PropTypes.oneOf(['light', 'dark']),
};

Hr.defaultProps = {
  variant: 'light',
};
